<template>
  <v-btn v-if="!isPlaying"
    text
    class="modal-cta mx-2"
    @click="$emit('play')">
    Play
    <v-icon class="ml-2">fas fa-caret-right</v-icon>
  </v-btn>
  <v-btn v-else
    text
    class="modal-cta mx-2"
    @click="$emit('pause')">
    Pause
    <v-icon class="ml-2">fas fa-pause</v-icon>
  </v-btn>
</template>

<script>
  export default {
    name: "playPauseButton",
    props: ["isPlaying"]
  }
</script>